export default ["standard", "positive", "medium", "negative"];
